import {InjectionToken} from "@angular/core";

export const MAT_DATE_LOCALE = new InjectionToken<string>('MAT_DATE_LOCALE');
